export const hexToRgba = (hex: string, alpha: number): string => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const buildLightAccentScale = (
  hex: string
): Record<'100' | '40' | '20' | '10' | '5', string> => {
  return {
    100: hex,
    40: hexToRgba(hex, 0.4),
    20: hexToRgba(hex, 0.2),
    10: hexToRgba(hex, 0.1),
    5: hexToRgba(hex, 0.05),
  };
};

export const buildDarkAccentScale = (
  hex: string
): Record<'100' | '80' | '60' | '40' | '30' | '20' | '10' | '5', string> => {
  return {
    100: hex,
    80: hexToRgba(hex, 0.8),
    60: hexToRgba(hex, 0.6),
    40: hexToRgba(hex, 0.4),
    30: hexToRgba(hex, 0.3),
    20: hexToRgba(hex, 0.2),
    10: hexToRgba(hex, 0.1),
    5: hexToRgba(hex, 0.05),
  };
};
